<template>
  <div>
    <button v-promise-btn @click.prevent="joinCampaign" v-text="label" />
  </div>
</template>

<script>
import { Bus } from '../bus';

export default {
  props: {
    preApprovalCampaign: { type: Boolean },
  },
  computed: {
    label() {
      if (this.preApprovalCampaign) return 'Apply to campaign';

      return 'Join campaign';
    },
  },
  methods: {
    joinCampaign() {
      Bus.$emit('focusCampaignForm');
    },
  },
};
</script>
